/* Вывод списка продуктов из созданных менюшек */

import React from 'react';
import {useSelector, useDispatch} from 'react-redux'
import {DishChecking} from '../MenuCreate/Checking'
import { resulted } from '../../../utils/utils.js'
import { addProduct } from '../../../store/reguestSlice'
import { getFoodList, updateFoodList, postFoodList, deleteFoodList } from '../../../store/api'
import { ProductCat, PrintThisComponent} from '../../atoms' 
import { SceletonProduct } from "../";
import './ProductList.css';

export function ProductList (props) {
  const {date, menuPlane, servings, changeMenuDay } = props 
  const { productList } = useSelector(state => state.productList) // База сохраненных продуктовых списков
  const { product } = useSelector(state => state.product)//создается на фронте
  const dispatch = useDispatch();
  const { recipes, sts } = useSelector(state => state.recipes)
  const { ingredients, status } = useSelector(state => state.ingredients)
  const { plans, statusPlan } = useSelector(state => state.plans)
  const { currentUser } = useSelector(state => state.currentUser)
  let startDay = date.length>0 ? new Date(date[0].date).toLocaleDateString() : ''
  let finishDay = date.length>0 ?  new Date(date[date.length-1].date).toLocaleDateString() : ''; 
  const [subDish, setSubDish] = React.useState([]) // Список блюд где исп-ся продукты
  const [print, setPrint] = React.useState(false)
  const { lib } = useSelector(state => state.lib)
  const [baseProducts, setBaseProducts] = React.useState([])//Сохраненный список (в базе) продуктов на выбранные даты
  //const check = Object.entries(baseProducts).length !== 0 && baseProducts.productList.some(f=> f.id === choiceIngredient._id);
 
  // Запрос списка продуктов при изменении даты
  React.useMemo(() => {
    dispatch(getFoodList(currentUser._id))
  },[currentUser])
 
  //если есть сохраненный список покупок записывает его в стэйт 
  React.useMemo(() => { 
    if(productList.length>0) {
      setBaseProducts(baseProductList())
    }
  },[productList]) 

  React.useMemo(() => { 
    if(Object.entries(baseProducts).length > 0 && changeMenuDay) {
      dispatch(deleteFoodList(baseProducts._id))
    } else if(Object.entries(baseProducts).length >0 && !changeMenuDay) {
      dispatch(addProduct(baseProducts.productList))
    } else {
      dispatch(addProduct(resulted(menuPlane, servings)))
    }
  },[date, menuPlane, changeMenuDay, baseProducts, plans])
 
  React.useMemo(() => {
    if(Object.entries(baseProducts).length > 0) {
      dispatch(deleteFoodList(baseProducts._id))
    }
   // dispatch(addProduct(resulted(menuPlane, servings))) 
  },[servings])
 
  //Проверяет наличие продуктов в списке для исключения повторного добавления
  /*React.useEffect(() => {
    if(check && status === 'resolved') {
      props.handleCheckProductList()
      resetIngForm()
    }
  },[check])*/

  //При изменении меню и пользователя пересчитывает в каких рецептах используются продукты
  React.useEffect(() => { 
    if(status === 'resolved') { 
      setSubDish(DishChecking(menuPlane, recipes, ingredients))
    }
  },[menuPlane, currentUser, status, recipes ]) 
 
  //Ищет список продуктов в базе на выбранные даты
  function baseProductList() { 
    let newArr= productList.find(i=>JSON.stringify(date) === JSON.stringify(i.date))
    if (newArr !== undefined) {
      return newArr
    } else {
      return newArr= []
    }
  }

  //Редактирование ингредиентов из общего списка продуктов
  function handleSaveEditProducts(item) {
    props.handleChangeMenu()
    const editFoodlist = product.map(k=> k.id === item.id ? item : k)
    if (baseProducts.length === 0) {
      dispatch(postFoodList({editFoodlist, date}))
    } else {
      dispatch(updateFoodList({cardId: baseProducts._id, editFoodlist}))
    }
  }
 
  function handlePrint() {
    setPrint(!print)
  }
  return (
      <section className='foodList'>
      <h3 className='foodlist__header font35Bold' onClick={props.handlePrint}>Список продуктов <PrintThisComponent/></h3>
      <p className='foodlist__subtitle font24Bold'>Список составлен автоматически, его можно редактировать</p>
      <p className='foodlist__paragraph font24Norm'>Отметьте галочкой те продукты, которые у вас уже есть дома. Они не будут добавлены в список покупок.</p>
      <p className='foodlist__text font16Norm'>Продукты указаны на {servings} чел, {startDay === finishDay ? `на 1 день: ${startDay}` : `c ${startDay} по ${finishDay}`}</p>
      { status === 'resolved' && statusPlan === 'resolved' && sts=== 'resolved' ?
        <div className='product-block'>
        <div className='product__buy'>
          {lib.catIn &&
          lib.catIn.map(i=> (
            <ProductCat 
              item={i} 
              key={i._id}
              checkFoodList={product}
              handleChoice={handleSaveEditProducts}
              subDish={subDish}
            />
          ))
          }
        </div>
      
      {/*choiceFoodList.length> 0 && 
      <div className='product-list'> 
      <p className='product-list__subtitle font24Bold'>Продукты которые есть дома</p>
      {choiceFoodList.map((item)=> (
        <ProductItem
        item={item} 
        key={item.id}
        handleChoice={handleSaveEditProducts}
        subDish={subDish}
      />
      ))}
      </div>
      */}
      </div>
      :  <SceletonProduct />
    }
    {/*excessFoodList.length> 0 &&
      <>
       <p className='foodList__subtitle'>Дополнительный список покупок</p>
       <div className='foodList__blok'>
       {
      excessFoodList.map((item)=> (
        <FoodItem 
          item={item} 
          key={item.id}
          handleDeleteProduct={handleDeleteProduct}
          handleSave={handleEditProduct}
          filtrMassiv={filtrMassiv}
          choiceIngredient={choiceIngredient}
          name={name}
          weight={weight}
          measure={measure}
          handleChoice={handleChoice}
          handleChangeInput={handleChangeName}
          handleChangeInputWeight={handleChangeWeight}
          handleChangeMeasure={handleChangeMeasure}
          submitDisabled={submitDisabled}
        />
        ))}</div>
         </>
      } 
      
       {choiceFoodList.length> 0 &&
      <>
       <p className='foodList__subtitle'>В наличии</p>
       <div className='foodList__blok'>
       {
      choiceFoodList.map((item)=> (
        <FoodItem 
          item={item} 
          key={item.id}
          handleDeleteProduct={handleDeleteProduct}
          handleSave={handleEditProduct}
          filtrMassiv={filtrMassiv}
          choiceIngredient={choiceIngredient}
          name={name}
          weight={weight}
          measure={measure}
          handleChoice={handleChoice}
          handleChangeInput={handleChangeName}
          handleChangeInputWeight={handleChangeWeight}
          handleChangeMeasure={handleChangeMeasure}
          submitDisabled={submitDisabled}
        />
        ))}</div>
        </>
      }   
      {checkFoodList.length> 0 &&
      <>
      <p className='foodList__subtitle'>В наличии</p>
      <div className='foodList__blok'>
      {
     checkFoodList.map((item)=> (
       <FoodItem 
         item={item} 
         key={item.id}
         handleDeleteProduct={handleDeleteProduct}
         handleSave={handleEditProduct}
         filtrMassiv={filtrMassiv}
         choiceIngredient={choiceIngredient}
         name={name}
         weight={weight}
         measure={measure}
         handleChoice={handleChoice}
         handleChangeInput={handleChangeName}
         handleChangeInputWeight={handleChangeWeight}
         handleChangeMeasure={handleChangeMeasure}
         submitDisabled={submitDisabled}
       />
       ))}</div>
       </>
     */  }  
       {/*<button type='button' className='menuweek-button color'>Добавить продукты</button>
      submitDisabled ?
      <div className='add-product_ingredients'>
        <AddIngredient //Добавление нового ингредиента
          filtrMassiv={filtrMassiv} 
          handleAutoText={handleAutoText}
          hidden={hidden}
          ingredient={ingredient}
          //ingError={ingError}
          //weightError={weightError}
          isDisabled={false}
          choiceIngredient={choiceIngredient}
          name={name}
          weight={weight}
          measure={measure}
          handleChangeInput={handleChangeName}
          handleChangeInputWeight={handleChangeWeight}
          handleChangeMeasure={handleChangeMeasure}
        />
        <button type='button' onClick={handleAddIng} className={`my-recipe__add-button item__link ${addIngDisabled ? ('add-form__button_disabled') : ''}`}>Добавить</button>
      </div>
      : ''
  */}
  
    </section>
  
  )
}